// new Date().getTime().toString(16) + (new Date().getTime() + Math.floor(Math.random()*1000)).toString(16) + (new Date().getTime() + Math.floor(Math.random()*1000)).toString(16)
export default {
    clone(str) {
        return JSON.parse(JSON.stringify(str))
    }
}

function QS() { }
// a=1&b=2 ==> {a:1,b:2}  
QS.prototype.parse = (attr) => {
    if (!attr) return {}
    let obj = {}
    attr.split('&').forEach(el => {
        var item = el.split("=")
        obj[item[0]] = item[1]
    });
    return obj
}
// {a:1,b:2} ==> a=1&b=2
QS.prototype.stringify = (attr) => {
    if (!attr) return {}
    var str = ''
    for (const key in attr) {
        if (Object.hasOwnProperty.call(attr, key)) {
            const element = attr[key];
            str += (key + '=' + element + "&")
        }
    }
    return str.slice(0, -1)
}
export let qs = new QS();